import { render, staticRenderFns } from "./MatriculasAtivasCard.vue?vue&type=template&id=6443a5bc&scoped=true"
import script from "./MatriculasAtivasCard.vue?vue&type=script&lang=js"
export * from "./MatriculasAtivasCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6443a5bc",
  null
  
)

export default component.exports